// extracted by mini-css-extract-plugin
export var container = "_7q-0";
export var icon = "_7q-1";
export var text = "_7q-2";